import script from "./HeaderAnim.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderAnim.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderAnim.vue?vue&type=style&index=0&id=0b62b2c9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_typescript@4.9.5__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b62b2c9"]])

export default __exports__